<template>
  <div class="page-jobs section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-tablet is-7-desktop is-6-widescreen">

          <div class="box search-box">
            <h1 class="title is-3 mb-2">Find Job</h1>
            <p class="subtitle is-6 has-text-grey">
              Search for a job using the Job ID.
            </p>

            <form @submit.prevent="getJobs">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input
                    class="input is-medium"
                    type="text"
                    v-model.trim="jobId"
                    placeholder="Enter Job ID"
                  >
                </div>

                <div class="control">
                  <button
                    class="button is-primary is-medium"
                    type="submit"
                    :class="{ 'is-loading': isLoading }"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div v-if="jobs.length" class="jobs-list">
            <div
              v-for="job in jobs"
              :key="job.id || job.generated_job_id"
              class="card job-card"
            >
              <div class="card-content">
                <div class="is-flex is-justify-content-space-between is-align-items-start mb-4">
                  <div>
                    <p class="heading mb-1">Job ID</p>
                    <h2 class="title is-5 mb-0">
                      {{ job.generated_job_id }}
                    </h2>
                  </div>

                  <span class="tag is-info is-light">
                    {{ job.status }}
                  </span>
                </div>

                <div class="job-row">
                  <span class="job-label">Address</span>
                  <span class="job-value">{{ job.job_address }}</span>
                </div>

                <div class="job-row">
                  <span class="job-label">Work Done</span>
                  <span class="job-value">
                    {{ job.work_done_description || 'No description added' }}
                  </span>
                </div>

                <div class="mt-5">
                  <router-link
                    :to="getJobDetailUrl(job)"
                    class="button is-link is-light is-fullwidth"
                  >
                    View Details
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="empty-state has-text-centered">
            <p class="has-text-grey">
              Enter a Job ID above to search for job details.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'

export default {
  name: 'JobsView',

  data() {
    return {
      jobs: [],
      jobId: '',
      isLoading: false
    }
  },

  mounted() {
    document.title = 'Jobs | SCE Electrical'
    this.jobId = localStorage.getItem('jobId') || ''
  },

  methods: {
    getJobId(job) {
      return job.generated_job_id.substring(1)
    },

    getJobDetailUrl(job) {
      const jobId = this.getJobId(job)
      return `/job/${jobId}`
    },

    showToast(message, type = 'is-danger') {
      toast({
        message,
        type,
        dismissible: true,
        pauseOnHover: true,
        duration: 2000,
        position: 'bottom-right',
      })
    },

    async getJobs() {
      const jobId = this.jobId

      if (!jobId) {
        this.showToast('Please enter a Job ID')
        return
      }

      this.isLoading = true
      this.$store.commit('setIsLoading', true)

      try {
        const response = await axios.get(`/api/v1/jobs/${jobId}/`)

        if (response.data.result === 'error') {
          this.jobs = []
          this.showToast(response.data.msg)
        } else {
          this.jobs = response.data
          this.$store.commit('setJobId', jobId)
          localStorage.setItem('jobId', jobId)
        }
      } catch (error) {
        console.log(error)
        this.showToast('Something went wrong. Please try again.')
      } finally {
        this.isLoading = false
        this.$store.commit('setIsLoading', false)
      }
    }
  }
}
</script>

<style scoped>
.page-jobs {
  min-height: 100%;
}

.search-box {
  border-radius: 12px;
}

.jobs-list {
  display: grid;
  gap: 1rem;
}

.job-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.75rem 1.5rem rgba(10, 10, 10, 0.08);
}

.job-row {
  padding: 0.85rem 0;
  border-top: 1px solid #eeeeee;
}

.job-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #7a7a7a;
  letter-spacing: 0.04em;
}

.job-value {
  display: block;
  color: #363636;
  line-height: 1.5;
}

.empty-state {
  padding: 2rem 1rem;
}
</style>